import React from 'react'
import { formatHour, formatMoney } from '../../../helpers/utils'
import { createReportDetailsTab } from './createReportDetailsTab'

const HEADERS = [
  { label: 'CÓDIGO', description: 'Número de identificación del usuario' },
  { label: 'USUARIO', description: 'Nombre del usuario' },
  { label: 'GRUPO', description: 'Grupo al que pertenecen los usuarios' },
  { label: 'ÚLTIMA ACTIVIDAD', description: 'Hora de última actividad registrada' },
  { label: 'VISITAS REALIZADAS', description: 'Cantidad total de visitas registradas' },
  { label: 'VISITAS FUERA DE RUTA', description: 'Visitas que no estaban asignadas' },
  { label: 'EFECTIVIDAD', description: 'Porcentaje de visitas efectivas sobre las realizadas' },
  {
    label: 'ACTIVIDADES DENTRO DE GEOCERCA',
    description: 'Actividades dentro de la zona permitida'
  },
  { label: 'TOTAL PEDIDOS', description: 'Monto total de pedidos realizados' }
]

function renderRow(model) {
  return (
    <>
      <td>{model.user_uid}</td>
      <td>{model.user_name}</td>
      <td>{model.user_group}</td>
      <td className="text-center">{formatHour(model.order_last_visit)}</td>
      <td className="text-center">
        {model.total_visited_clients}/{model.all_executed_clients}
      </td>
      <td className="text-center">{model.out_of_route_clients}</td>
      <td className="text-center">{model.order_percent_effective}%</td>
      <td className="text-center">
        {model.order_location_effective_count}/{model.order_location_available_count}
      </td>
      <td className="text-center">{formatMoney(model.total_order)}</td>
    </>
  )
}

export default createReportDetailsTab({
  displayName: 'ReportOrdersTab',
  headers: HEADERS,
  renderRow
})
